<template lang="pug">
v-dialog(v-model="dialog", width="450")
  template(v-slot:activator="{ on }")
    v-list-item(outlined, small, color="secondary", v-on="on")
      span Set Bulk Printing Group
  v-card
    v-toolbar(flat, dense)
      .subtitle-2 Set All Items Printing Group
    v-divider
    v-form(@submit.prevent="save")
      v-card-text
        Note(:courseId="courseId")
        v-btn-toggle.mb-3(v-model="printingGroup", color="secondary", multiple)
          v-btn(
            @click.stop,
            v-for="(item, index) in biz.printingGroups",
            :key="index",
            :value="item._id",
            :title="item.name"
          ) {{ item.name }}
        v-btn(type="submit", block, color="secondary", :loading="loading") Save
</template>

<script>
import { mapGetters } from "vuex";
import Note from "./Note";

export default {
  components: { Note },
  props: {
    courseId: { type: String, default: null },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      printingGroup: [],
    };
  },
  computed: {
    ...mapGetters(["biz"]),
  },
  methods: {
    async save() {
      if (!this.biz) return;
      this.loading = true;
      this.biz.dishes.forEach((o) => {
        if (o.course == this.courseId) o.printingGroup = this.printingGroup;
      });
      try {
        const action = { $set: { dishes: this.biz.dishes } };
        const data = await this.$api.biz.put(this.biz._id, action);
        this.$store.dispatch("setBiz", data);
        this.printingGroup = null;
        this.dialog = false;
      } catch (e) {
        this.$toast.error(e.response?.data || e.message);
      }
      this.loading = false;
    },
  },
};
</script>
